import Tree from './src/tree.vue'

export default Tree



// WEBPACK FOOTER //
// ./src/public/components/kye-tree/index.js